module.exports = __webpack_public_path__ + "img/grey-top2.10c115c1.png";